var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerList !== null && _vm.bannerList.list.length >= 1)?_c('PMobileCarouselBanner',{attrs:{"banner-list":_vm.bannerList.list}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }